import React from 'react';
import classNames from 'classnames';

import { paths } from 'client/shared/Paths';
import { useT } from 'client/i18n/hooks/useT';
import Link from '../Link';

import styles from './styles.sass';

const LegalTabNavigation = ({ pathname }) => {
  const t = useT();
  return (
    <ul className={styles.list}>
      <li
        className={classNames(styles.listItem, {
          [styles.listItemSelected]: pathname === paths.legal.tos,
        })}
      >
        <Link
          to={paths.legal.tos}
          className={classNames(styles.link, {
            [styles.selected]: pathname === paths.legal.tos,
          })}
          aria-current={pathname === paths.legal.tos ? 'page' : null}
        >
          {t(
            'Link.TermsOfService',
            'Terms of Service',
            'Terms of Service link text'
          )}
        </Link>
      </li>
      <li
        className={classNames(styles.listItem, {
          [styles.listItemSelected]: pathname === paths.legal.privacy,
        })}
      >
        <Link
          to={paths.legal.privacy}
          className={classNames(styles.link, {
            [styles.selected]: pathname === paths.legal.privacy,
          })}
          aria-current={pathname === paths.legal.privacy ? 'page' : null}
        >
          {t(
            'Link.PrivacyPolicy',
            'Privacy Policy',
            'Privacy Policy link text'
          )}
        </Link>
      </li>
      <li
        className={classNames(styles.listItem, {
          [styles.listItemSelected]: pathname === paths.legal.dmca,
        })}
      >
        <Link
          to={paths.legal.dmca}
          className={classNames(styles.link, {
            [styles.selected]: pathname === paths.legal.dmca,
          })}
          aria-current={pathname === paths.legal.dmca ? 'page' : null}
        >
          DMCA
        </Link>
      </li>
      <li
        className={classNames(styles.listItem, {
          [styles.listItemSelected]: pathname === paths.legal.ccpa,
        })}
      >
        <Link
          to={paths.legal.ccpa}
          className={classNames(styles.link, {
            [styles.selected]: pathname === paths.legal.ccpa,
          })}
          aria-current={pathname === paths.legal.ccpa ? 'page' : null}
        >
          CCPA
        </Link>
      </li>
    </ul>
  );
};

export { LegalTabNavigation };
